import React, { FC, useRef } from 'react'
import AddToCollectionIcon from 'svg/add-to-collection.svg'
import AddToCollectionFilledIcon from 'svg/add-to-collection-filled.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'
import CreateCollectionsModal, {
  CreateCollectionsModalApi,
} from 'components/SACollection/components/CreateCollectionsModal'
import AddToCollectionComponent, {
  AddToCollectionApi,
} from 'components/Artworks/Actions/AddToCollection'
import useSearchProvider from 'hooks/useSearchProvider'

type AddToCollectionProps = {
  artworkId: number
  isAddedToCollection?: boolean
}

const AddToCollection: FC<AddToCollectionProps> = ({ artworkId, isAddedToCollection }) => {
  const { getSearchProviderAttributes } = useSearchProvider()
  const createCollectionsModalRef = useRef<CreateCollectionsModalApi>(null)
  const addToCollectionRef = useRef<AddToCollectionApi>(null)
  const modalName = `${artworkId}`

  const handleOpenCreateCollectionsModal = () => {
    createCollectionsModalRef.current?.handleOpenModal()
  }

  const handleCloseCollectionsListModal = () => {
    addToCollectionRef.current?.handleCloseCollectionsListModal()
  }

  const handleCreateCollectionOnSuccess = (payload) => {
    addToCollectionRef.current?.handleCreateCollectionCallback(payload)
    handleCloseCollectionsListModal()
  }

  return (
    <button
      className={styles.iconButtonDefaultStyle}
      data-action='collection'
      data-type='action'
      title='Add to Collection'
      rel='nofollow'
      {...getSearchProviderAttributes([{ 'button-action': 'add_to_wishlist' }])}
    >
      <AddToCollectionComponent
        modalName={modalName}
        artworkId={artworkId}
        handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
        ref={addToCollectionRef}
      >
        <div className={styles.iconActionContainer}>
          <AddToCollectionFilledIcon
            className={classNames(styles.iconActionAddToCollection, {
              [styles.iconActionContainerInvisible]: !isAddedToCollection,
            })}
          />
          {!isAddedToCollection && (
            <AddToCollectionIcon className={styles.iconActionAddToCollection} />
          )}
        </div>
      </AddToCollectionComponent>
      <CreateCollectionsModal
        ref={createCollectionsModalRef}
        onSuccess={handleCreateCollectionOnSuccess}
      />
    </button>
  )
}

export default AddToCollection
